'use client'

import React from 'react'
import { useLocation, NavLink } from 'react-router-dom'
import { useAuth } from '@/contexts/auth-context'
import { Button } from '@/components/ui/button'
import { LayoutDashboard, LogOut, Settings, Users, Hospital } from 'lucide-react'

const navItems = [
  { name: 'Dashboard', href: '/admin/dashboard', icon: LayoutDashboard },
  { name: 'Users', href: '/admin/users', icon: Users },
  { name: 'Settings', href: '/admin/settings', icon: Settings },
]

export const AdminSidebar: React.FC = () => {
  const { signOut, user } = useAuth()

  return (
    <div className="flex flex-col w-64 bg-gray-900 text-gray-200">
      <div className="flex items-center justify-center h-20 border-b border-gray-800">
        <Hospital className="h-8 w-8 text-blue-500" />
        <h1 className="ml-3 text-2xl font-bold text-white">Admin Panel</h1>
      </div>
      <nav className="flex-1 px-4 py-6 space-y-2">
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            end={item.href === '/admin/dashboard'}
            className={({ isActive }) =>
              `flex items-center px-4 py-2.5 rounded-lg transition-colors duration-200 ${
                isActive
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'hover:bg-gray-800 hover:text-white'
              }`
            }
          >
            <item.icon className="w-5 h-5 mr-4" />
            <span className="font-medium">{item.name}</span>
          </NavLink>
        ))}
      </nav>
      <div className="px-4 py-6 border-t border-gray-800">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-11 h-11 rounded-full bg-blue-500 flex items-center justify-center font-bold text-white">
            {user?.email?.[0]?.toUpperCase() ?? 'A'}
          </div>
          <div className="flex-1 truncate">
            <p className="font-semibold text-sm text-white truncate">
              {user?.user_metadata?.first_name || 'Admin User'}
            </p>
            <p className="text-xs text-gray-400 truncate">{user?.email}</p>
          </div>
        </div>
        <Button
          variant="ghost"
          className="w-full justify-start text-gray-400 hover:bg-gray-800 hover:text-white"
          onClick={() => signOut()}
        >
          <LogOut className="mr-3 h-5 w-5" />
          Log Out
        </Button>
      </div>
    </div>
  )
} 